import { OverlayTrigger, Popover } from 'react-bootstrap'
import { Event } from '../../../../model/domain/event'
import { useTranslation } from 'react-i18next'
import { translate } from '../../../../../I18n/i18n'
import { useState } from 'react'
import './CustomEvent.scss'
import { User } from '../../../../model/domain/user'
import { Role } from '@cuatroochenta/co-admin-react-library'

interface CustomEventProps {
    event: Event | any
    user?: User
    onEdit: (eventId: number) => void
    onDelete: (eventId: number) => void
}

export default function CustomEvent({
    event,
    user,
    onEdit,
    onDelete,
}: CustomEventProps) {
    const [showPopover, setShowPopover] = useState(false)
    const { t } = useTranslation()

    const popover = (
        <Popover
            id={`popover-${event.id}`}
            className="event-popover"
            onMouseEnter={() => setShowPopover(true)}
            onMouseLeave={() => setShowPopover(false)}
        >
            <Popover.Header style={{ backgroundColor: event.color }}>
                <div className="event-popover-title-container">
                    <p className="event-popover-title">{event.title}</p>
                    {(user?.data.roles.includes(Role.SUPERADMIN) ||
                        user?.data.id === event.userId) && (
                        <div className="event-popover-actions">
                            <button onMouseDown={() => onEdit(event.id)}>
                                <i className="fa fa-edit"></i>
                            </button>
                            <button onMouseDown={() => onDelete(event.id)}>
                                <i className="fa fa-trash-can"></i>
                            </button>
                        </div>
                    )}
                </div>
            </Popover.Header>
            <Popover.Body>
                <p className="event-popover-description">
                    {event.description ??
                        translate(t, 'calendar.TR_EVENT_NO_DESCRIPTION')}
                </p>
            </Popover.Body>
        </Popover>
    )

    return (
        <>
            <OverlayTrigger
                trigger={['hover', 'focus']}
                overlay={popover}
                show={showPopover}
                onToggle={(show) => setShowPopover(show)}
            >
                <strong className="event-title">{event.title}</strong>
            </OverlayTrigger>
        </>
    )
}
